module.exports = {
        srcSet: __webpack_public_path__ + "static/media/staff-melvin-rostek-200.f6f095870113a9d5f0dcfe6258d15b03.webp"+" 200w",
        images: [{path: __webpack_public_path__ + "static/media/staff-melvin-rostek-200.f6f095870113a9d5f0dcfe6258d15b03.webp",width: 200,height: 200}],
        src: __webpack_public_path__ + "static/media/staff-melvin-rostek-200.f6f095870113a9d5f0dcfe6258d15b03.webp",
        toString: function(){return __webpack_public_path__ + "static/media/staff-melvin-rostek-200.f6f095870113a9d5f0dcfe6258d15b03.webp"},
        
        width: 200,
        height: 200
      }